export default __webpack_public_path__ + "static/Profile-Aernoud_Bourdrez-f014e9710e0f880291cce363829f0866.png";